import Vue from "vue";
import dynamicList from "./dynamicList";
import animated from "animate.css";


import "./../../css/global.scss";

Vue.use(animated);

// 引入自定义Loading
import loading from '@/components/Loading/index.js'
Vue.directive('loading', loading)

new Vue({
  render: (h) => h(dynamicList),
}).$mount("#app");
